import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AuftragBodenbedeckungSelectionMeta, CodeEntry } from 'app/core/batch-auftrag-api';
import { GbcapicodeService } from 'app/core/stammdaten-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslateNamePipe } from '../../../../../shared/pipes/simple/translate-name.pipe';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '../../../../../shared/components/abstract-component/abstract.component';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cap-auftrag-bodenbedeckung-selection',
  templateUrl: './auftrag-bodenbedeckung-selection.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragBodenbedeckungSelectionComponent),
      multi: true
    }
  ],
  imports: [
    CapFormControlComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    NgbTooltip,
    TranslatePipe,
    TranslateNamePipe
  ]
})
export class AuftragBodenbedeckungSelectionComponent extends AbstractComponent implements OnInit, ControlValueAccessor {
  @Input()
  heading = 'GrundstueckMitFolgendenBodenbedeckungen';

  @Input()
  mitBodenbedeckungsGeschichte: boolean;

  @Input()
  disabled: boolean;

  model: AuftragBodenbedeckungSelectionMeta;
  bedeckungen: CodeEntry[] = [];
  booleanBedeckungen: boolean[] = [];

  isToggleAll = false;
  orderData: Array<{ item: CodeEntry; checked: boolean }> = [];

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor(
    private capiCodeService: GbcapicodeService,
    private translateService: TranslateService,
    private translateNamePipe: TranslateNamePipe
  ) {
    super();
    keysToTranslate(['GrundstueckMitFolgendenBodenbedeckungen']);
  }

  ngOnInit(): void {
    this.addSub(this.translateService.onLangChange.subscribe(() => this.sortCodes()));
  }

  @Input()
  set template(template: AuftragBodenbedeckungSelectionMeta) {
    this.model = template;
    this.booleanBedeckungen = [];
    if (this.bedeckungen.length === 0) {
      this.capiCodeService.loadCapiCodes('BODENBEDECKUNG', true).subscribe((i) => {
        this.bedeckungen = i;
        this.init();
        this.calculateEntries();
      });
    } else {
      this.init();
    }
  }

  init() {
    this.bedeckungen.forEach((item, index) => {
      this.orderData[index] = { item: item, checked: false };
      if (this.model.bodenbedeckungCodes.map((code) => code.id.id).includes(this.orderData[index].item.id.id)) {
        this.orderData[index].checked = true;
      }
    });
    this.sortCodes();
  }

  sortCodes() {
    this.orderData.sort((a, b) => {
      return this.translateNamePipe.transform(a.item.text).localeCompare(this.translateNamePipe.transform(b.item.text));
    });
  }

  addRemove(pos: any, $event) {
    if (!this.disabled) {
      pos.checked = !pos.checked;
      this.calculateEntries();
    }
  }

  calculateEntries() {
    this.model.bodenbedeckungCodes = [];
    this.orderData.forEach((element) => {
      if (element.checked) {
        this.model.bodenbedeckungCodes.push(element.item);
      }
    });
  }

  writeValue(template: AuftragBodenbedeckungSelectionMeta): void {}

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  toggleAllCheckboxes() {
    if (this.isToggleAll) {
      this.orderData.forEach((item) => (item.checked = true));
    } else {
      this.orderData.forEach((item) => (item.checked = false));
    }
  }

  isAllChecked(): boolean {
    return this.orderData.every((a) => a.checked);
  }
}
